import React from 'react';
import { Box, Typography } from '@lucid/lego';
import { formatCurrency } from '../../../../utils/tools';
import styles from './Feature.module.scss';

type FeatureProps = {
  description: string;
  price: number;
  currencyCode: string;
  theme: 'dark' | 'light';
};

/**
 * Feature component for displaying vehicle options and features
 * @component
 */
const Feature: React.FC<FeatureProps> = ({ description, price, currencyCode, theme }) => (
  <Box className={styles.featureRow} theme={theme}>
    <Box className={styles.featureLabel}>
      <Typography variant="body" size="small" theme={theme}>
        {description}
      </Typography>
    </Box>
    <Box className={styles.featurePrice}>
      <Typography variant="body" size="small" theme={theme}>
        {price === 0 ? 'Included' : formatCurrency(price, currencyCode)}
      </Typography>
    </Box>
  </Box>
);

Feature.displayName = 'Feature';

export default Feature;
